import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { ConvergenceAnonymousFormSubmitInitialStateType, ConvergenceAnonymousFormSubmitType } from '../../../models/convergence/convergence-anonymous-form-submit-model';
import ConvergenceAnonymousFormSubmitService from '../../../services/convergence/convergence-anonymous-form-submit.service';

const initialState: ConvergenceAnonymousFormSubmitInitialStateType = {
    ConvergenceAnonymousFormSubmitData: [],
    ConvergenceAnonymousFormSubmitLoading: true,
    ConvergenceAnonymousFormSubmitError: undefined
};

export const postConvergenceAnonymousFormSubmit = createAsyncThunk('ConvergenceAnonymousFormSubmit/retrieve',
    async (formBody: ConvergenceAnonymousFormSubmitType , { rejectWithValue }) => {
        try {

            const response = await ConvergenceAnonymousFormSubmitService.postConvergenceAnonymousFormSubmitService(formBody)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const ConvergenceAnonymousFormSubmitSlice = createSlice({
    name: 'ConvergenceAnonymousFormSubmit',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postConvergenceAnonymousFormSubmit.pending, (state) => {
                state.ConvergenceAnonymousFormSubmitLoading = true;
            })
            .addCase(postConvergenceAnonymousFormSubmit.fulfilled, (state, action) => {
                if (action.payload) {
                    state.ConvergenceAnonymousFormSubmitLoading = false;
                    state.ConvergenceAnonymousFormSubmitData = action.payload as ConvergenceAnonymousFormSubmitType[];
                }
            })
            .addCase(postConvergenceAnonymousFormSubmit.rejected, (state, { payload }) => {
                state.ConvergenceAnonymousFormSubmitLoading = false;
                state.ConvergenceAnonymousFormSubmitError = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default ConvergenceAnonymousFormSubmitSlice.reducer;
